export enum zoomFactor {
Planet = 10,
Solar = 4.2,
Local = 1,
Sector = 0.4,
Quadrant = 0.2,
Max = 0.1,
}